import { useQuery } from '@tanstack/react-query';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import useApi from '../../api/backendApiContext';
import { ReactQueryConstants } from '../../commons/constants';
import { QueryStatus } from '../../commons/components/QueryStatus';

export const useFetchedOutlookOauth = (userId: string) => {
  const { outlookApi } = useApi();
  const cacheManager = useQueryCacheManager();
  const queryKey = cacheManager.getOutlookOauthCacheName(userId);
  const query = useQuery(queryKey, async () => outlookApi.getOauth(userId), {
    refetchOnWindowFocus: true,
    staleTime: ReactQueryConstants.personalIntegrationSettingsStaleTime,
  });

  const queryStatusComponent = (
    <QueryStatus
      queryKey={queryKey}
      queryStatus={query.status}
      dataTestPrefix="chats"
      failedToLoadText="Something went wrong while loading Outlook Calendar integration settings."
    />
  );

  return {
    query,
    queryStatusComponent,
  };
};
